import React from 'react'
import { DebounceInput as ReactDebounceInput } from 'react-debounce-input'

export default
class DebounceInput extends React.Component {

  render() {
    const { field, form, placeholder, ...props } = this.props;
    return(
      <ReactDebounceInput
        placeholder={placeholder}
        minLength={1} 
        debounceTimeout={1000}
        onChange={e => form.setFieldValue(field.name, e.target.value)}
        value={field.value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/form/components/input/DebounceInput.jsx